import { Box } from '@mui/material';

import UserAvatar from '@components/UserAvatar';
import { IAvatarBox } from './interfaces';
import { useStyles } from './styles';

const AvatarBox = ({ avatar, name, avatarFallback = '' }: IAvatarBox) => {
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      <Box sx={classes.avatar}>
        <UserAvatar src={avatar} name={avatarFallback} />
      </Box>

      <Box sx={classes.name}>
        {name}
      </Box>
    </Box>
  );
};

export default AvatarBox;
